import { useAppState } from '../../../AppStateProvider';
import { ContactsAvailabilityStatus } from '../../../domain/user';
import { AppMode } from '../../../services/appStore';
import { useUserQuery } from '../../user/useUserQuery';

export const useContactsAvailabilityStatus = () => {
  const { data } = useUserQuery();
  const { mode } = useAppState();

  return {
    isContactsDisabled:
      data?.contactsAvailability === ContactsAvailabilityStatus.DisabledByAccount ||
      (mode !== AppMode.Extension && data?.contactsAvailability === ContactsAvailabilityStatus.PendingApproval),
    isGdprRestricted: data?.contactsAvailability
      ? data?.contactsAvailability === ContactsAvailabilityStatus.DisabledByCountry
      : true,
  };
};
